// src/ui/getVercelAIMessages.tsx
import {
  getExternalStoreMessages
} from "@assistant-ui/react";
var getVercelAIMessages = (message) => {
  return getExternalStoreMessages(message);
};
export {
  getVercelAIMessages
};
//# sourceMappingURL=getVercelAIMessages.js.map